import useTranslation from 'next-translate/useTranslation';
import GameSearchInput from '../../GameSearchInput';
import GamesByProviderBreadcrumbs from './Breadcrumb';
import { useDispatch } from 'react-redux';
import { resetSearchGame } from '@/lib/store/casino/actions';
import { useEffect } from 'react';
import styles from './styles.module.scss';
import Link from 'next/link';

export default function GamesByProviderHeader() {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();

  function onUnmount() {
    return () => {
      dispatch(resetSearchGame());
    };
  }

  useEffect(onUnmount, [dispatch]);

  return (
    <div className={styles.container}>
      <div className={styles.container__row}>
        <GamesByProviderBreadcrumbs />
        <Link className={styles.container__link} href="/games/providers">
          {t('see_all_providers')}
        </Link>
      </div>

      <GameSearchInput />
    </div>
  );
}
